/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {

    export class EgiftMinMaxBuyAmount implements angular.IDirective {
        restrict = "A";
        require = ['ngModel', '^form'];
        link = (scope: any, element: JQuery, attrs: any, ctrl: [angular.INgModelController, angular.IFormController]) => {

            const modelCtrl = ctrl[0];
            const formCtrl = ctrl[1];

            scope.$watch(attrs.ngModel, (newVal, oldVal) => {
                if (newVal === oldVal) return;
                let min, max;

                if (attrs.name == 'minBuy' || attrs.name == 'maxBuy') {
                    min = 'minBuy';
                    max = 'maxBuy';
                } else if (attrs.name == 'minGet' || attrs.name == 'maxGet') {
                    min = 'minGet';
                    max = 'maxGet';
                } else if (attrs.name == 'minDiscountFree' || attrs.name == 'maxDiscountFree') {
                    min = 'minDiscountFree';
                    max = 'maxDiscountFree';

                }
                formCtrl[min].$setValidity('moreThenMaxAmount', true);
                formCtrl[max].$setValidity('lessThenMaxAmount', true);

                if (attrs.name == min) {
                    if (Number(modelCtrl.$viewValue) > Number(scope.$eval(attrs.maxAmount)) && Number(formCtrl[max].$viewValue) != 0 ) {
                        formCtrl[max].$setValidity('lessThenMaxAmount', false);

                        if (attrs.isMinMaxFieldsRed) formCtrl[min].$setValidity('moreThenMaxAmount', false)
                    }
                }

                if (attrs.name == max) {
                    if (Number(modelCtrl.$viewValue) < Number(formCtrl[min].$viewValue) && Number(modelCtrl.$viewValue) != 0) {
                        formCtrl[min].$setValidity('moreThenMaxAmount', false);

                        if (attrs.isMinMaxFieldsRed) formCtrl[max].$setValidity('lessThenMaxAmount', false)
                    }
                }
            });
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EgiftMinMaxBuyAmount();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('egiftMinMaxBuyAmount', EgiftMinMaxBuyAmount.factory());
}